// fertigungs-monitor/frontend/src/App.tsx
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import RequireAuth from "./guards/RequireAuth";
import RequireAdmin from "./guards/RequireAdmin";
import AdminLayout from "./components/AdminLayout";
import ViewRouter from "./components/ViewRouter";
import MainLayout from "./components/MainLayout";

function App() {
  console.log(
    `🚨 App component rendered, current path:`,
    typeof window !== "undefined" ? window.location.pathname : "SSR",
  );

  return (
    <AuthProvider>
      <Routes>
        {/* Admin-Bereich - mit neuer Guard-Struktur */}
        <Route
          path="/admin"
          element={
            <RequireAuth>
              <RequireAdmin>
                <AdminLayout />
              </RequireAdmin>
            </RequireAuth>
          }
        />

        {/* Kiosk Display-Routen (keine Auth erforderlich) */}
        <Route
          path="/display/:displayId"
          element={<ViewRouter isKioskMode={true} />}
        />

        {/* Dynamische Standard-Ansichten mit Auth-Check */}
        <Route
          path="/*"
          element={
            <RequireAuth>
              <MainLayout>
                <ViewRouter />
              </MainLayout>
            </RequireAuth>
          }
        />
      </Routes>
    </AuthProvider>
  );
}

export default App;
